const tooltips = {
  exercise: {
    tags: {
      title: 'Use tags like #speed #agility #mobility #prehab #standing to help you tag your exercises so you can filter and find them quickly when planning your workout classes later.',
    }
  },
  class: {
    tags: {
      title: 'Use tags like #speed #agility #mobility #prehab #standing to help you tag your classes so you can filter and find them quickly when planning your playbooks later.',
    }
  },
  playbook: {
    tags: {
      title: 'Use tags like #speed #agility #mobility #prehab #standing to help you tag your playbooks.',
    }
  },
};

export default tooltips;
